module.exports = __webpack_public_path__ + "img/vertical_3_7_0.3b5208de.png";